<template>
  <Select
    v-model="name"
    filterable
    remote
    placeholder="请输入产品名称"
    :remote-method="handleRemoteMethod"
    :loading="loading"
    @change="handleChange"
  >
    <Option
      v-for="item in options"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    />
  </Select>
</template>

<script>
import { Select, Option } from 'element-ui';

import requestMixins from '../../mixins/request';

export default {
  components: {
    Select,
    Option,
  },
  mixins: [requestMixins],

  props: {
    defaultName: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      name: this.defaultName,
      loading: false,
      options: [],
    };
  },

  methods: {
    async handleRemoteMethod(query) {
      if (query === '') return;
      const options = await this.queryProductName(query);
      this.options = options;
    },

    handleChange(id) {
      this.$emit('change', id);
    },
  },
};
</script>
